import { ITheme, WhiteTheme } from "@view/constants/theme/theme";
import React, { PropsWithChildren, useState } from "react";

export const ThemeContext = React.createContext<{
  theme: ITheme;
  setTheme?: (theme: ITheme) => void;
}>({
  theme: WhiteTheme,
});

const ThemeContainer = (props: PropsWithChildren<{}>): JSX.Element => {
  const [theme, setTheme] = useState<ITheme>(WhiteTheme);

  return (
    <ThemeProvider value={{ setTheme, theme }}>{props.children}</ThemeProvider>
  );
};

export const ThemeProvider = ThemeContext.Provider;

export default ThemeContainer;
